// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AEKL","col":"styles_col__txJrK"};